<script lang="ts">
	import Form from '$lib/components/WoltAdvisor/Form.svelte'
	export let backgroundImage = '/images/backgrounds/woltair-homepage-background-de.webp'
	export let backgroundImageMobile =
		'/images/backgrounds/woltair-homepage-background-de-mobile.webp'
	export let navHeight = 80
	export let title: string
	export let showHVAC: boolean
	export let showPV: boolean

	// WIP header review component
	// export let reviews = [
	// 	{
	// 		text: 'Vybral jsem si Woltair a musím napsat, že jsem nadšený. 12.6.2023 jsem poslal veškeré dokumenty, 19.6 jsme dostal info.',
	// 		name: 'Lukáš Vacík',
	// 		photo: '/images/backgrounds/woltair-homepage-background-mobile.webp'
	// 	}
	// ]
</script>

<div class="page-fullwidth -mt-32 h-fit">
	<div class="hidden sm:block">
		<div class="absolute -z-10 h-full w-full bg-black" />
		<div
			class="absolute -z-10 h-full w-full bg-cover bg-center bg-no-repeat opacity-50 blur-3xl"
			style:background-image="url('{backgroundImage}')"
		/>
	</div>

	<div
		class="bg-image background z-20 mx-auto h-fit max-w-[2000px] shadow-2xl"
		style:padding-top="{navHeight}px"
	>
		<div class="md:page-wrapper mx-2 pt-12 md:py-24 md:pb-48">
			<div class="relative z-10 max-h-full w-fit max-w-full rounded-2xl bg-w-blue-950">
				<Form {title} {showHVAC} {showPV} />
			</div>
		</div>
		<img src={backgroundImageMobile} alt="background" class="-mt-8 md:hidden" />
	</div>
	<!-- WIP header review component -->
	<!-- <div class="bg-white sm:hidden">
		<div class="custom-border relative mx-2 -mt-16 mb-2 rounded-xl p-8 shadow-md backdrop-blur-xl">
			<p class="text-sm leading">
				Vybral jsem si Woltair a musím napsat, že jsem nadšený. 12.6.2023 jsem poslal veškeré
				dokumenty, 19.6 jsme dostal info.
			</p>
			<p class="mt-2 text-sm">Lukáš Vacík</p>
		</div>
	</div> -->
</div>

<style lang="scss">
	.background {
		@apply bg-white;

		@screen md {
			@apply bg-[url('/images/backgrounds/woltair-homepage-background-de.webp')] bg-cover bg-top bg-no-repeat;
		}
	}
</style>
